import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'scoreIcon',
    standalone: false
})
export class ScoreIconPipe implements PipeTransform {
  public transform(score: number) {
    const root = 'assets/svg/face-badge/';
    switch (score) {
      case -1:
        return root + 'none' + '.svg';
      case 0:
        return root + 'poor' + '.svg';
      case 1:
        return root + 'fair' + '.svg';
      case 2:
        return root + 'good' + '.svg';
      case 3:
        return root + 'excellent' + '.svg';
    }
    return root + 'none' + '.svg';
  }
}
